import { createFileRoute } from "@tanstack/react-router";
import Articulo from "@/pages/Articulo";
import { getArticleBySlug } from "@/data/articles";

export const Route = createFileRoute("/articulos/$slug")({
  head: ({ params }) => {
    const article = getArticleBySlug(params.slug);
    if (!article) {
      return {
        meta: [{ title: "Artículo no encontrado | TiemposHoy" }, { property: "og:title", content: "Artículo no encontrado | TiemposHoy" }, { property: "og:type", content: "article" }, { name: "twitter:card", content: "summary" }, { name: "description", content: "El artículo que buscas no existe o fue movido. Consulta otras guías de TiemposHoy." }, { property: "og:description", content: "El artículo que buscas no existe o fue movido. Consulta otras guías de TiemposHoy." }],
      };
    }
    const url = `https://tiemposhoy.com/articulos/${article.slug}`;
    const articleJsonLd = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Article",
      headline: article.title,
      description: article.description,
      datePublished: article.date,
      dateModified: article.date,
      author: { "@type": "Organization", name: "TiemposHoy.com" },
      publisher: {
        "@type": "Organization",
        name: "TiemposHoy.com",
        url: "https://tiemposhoy.com",
      },
      mainEntityOfPage: url,
    });
    return {
      meta: [
        { title: article.title },
        { name: "description", content: article.description },
        { name: "keywords", content: article.keywords },
        { property: "og:title", content: article.title },
        { property: "og:description", content: article.description },
        { property: "og:type", content: "article" },
        { name: "twitter:card", content: "summary" },
        { property: "og:url", content: url },
      ],
      links: [{ rel: "canonical", href: url }],
      scripts: [{ type: "application/ld+json", children: articleJsonLd }],
    };
  },
  component: Articulo,
});
